import { render, staticRenderFns } from "./commission.vue?vue&type=template&id=2a423c91&scoped=true"
import script from "./commission.vue?vue&type=script&lang=ts"
export * from "./commission.vue?vue&type=script&lang=ts"
import style0 from "./commission.vue?vue&type=style&index=0&id=2a423c91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a423c91",
  null
  
)

export default component.exports